/**
 * Mitarbeiter-Helper. PIN wird in localStorage abgelegt (persistent über Sessions, da Tablets/Smartphones)
 */
const STAFF_KEY = "groemitzer_staff_pin";

export const saveStaffPin = (pin) => {
  if (pin) localStorage.setItem(STAFF_KEY, pin);
};

export const getStaffPin = () => localStorage.getItem(STAFF_KEY);

export const clearStaffPin = () => localStorage.removeItem(STAFF_KEY);

export const staffHeaders = () => {
  const pin = getStaffPin();
  return pin ? { "X-Staff-PIN": pin } : {};
};

export const isStaffLoggedIn = () => !!getStaffPin();
